import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/data/site";
import { categories } from "@/data/categories";

export default function Footer() {
  const { t } = useTranslation();

  const quickCategories = categories.slice(0, 5);

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-primary-800">
                <i className="ri-grid-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {t("brand")}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-background-50">
              {t("footer.resources")}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <Link
                  to="/article/what-is-basetao-spreadsheet"
                  className="text-sm text-background-100/80 hover:text-background-50 cursor-pointer transition-colors"
                >
                  {t("article.cardTitle")}
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-100/80 hover:text-background-50 cursor-pointer transition-colors"
                >
                  {t("categories.title")}
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-100/80 hover:text-background-50 cursor-pointer transition-colors"
                >
                  {t("faq.title")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-background-50">
              {t("footer.quickLinks")}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-100/80 hover:text-background-50 cursor-pointer transition-colors"
                >
                  {t("cta.visitMain")}
                </a>
              </li>
              {quickCategories.map((c) => (
                <li key={c.key}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-100/80 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {t(`categories.${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-relaxed text-background-100/60">
            {t("footer.disclaimer")}
          </p>
          <p className="mt-3 text-xs text-background-100/60">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}